import { render } from "./BlogDetalheView.vue?vue&type=template&id=17835bfb"
import script from "./BlogDetalheView.vue?vue&type=script&lang=js"
export * from "./BlogDetalheView.vue?vue&type=script&lang=js"

import "./BlogDetalheView.vue?vue&type=style&index=0&id=17835bfb&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Seleto industrial\\desenv\\FrontSite\\CodigoVueFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__